<div class="">
    <div class="background-tc fixed-top">
        <div class="container header-menu_mobile">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand " routerLink="">
                    <img src="../../../assets/images/logo-white.svg" alt="Logo toyosa" class="d-block w-100 py-2 logo"/>
                </a>
                <div class="d-flex align-items-center ms-auto">
                    <button class="gs-trigger-mobile mx-2" type="button" aria-label="Buscar" (click)="abrirBuscador()">
                        <i class="bi bi-search"></i>
                    </button>
                    <button class="w-10 navbar-toggler mx-3" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation" (click)="viewMenuPrincipal()">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
        </div>
        
        <div class="menu-principal" *ngIf="menuPrincipal">
            <div class="row">
                <div class="col-8 menu-principal_items">
                    
                    <ng-template #userData>
                        <div class="wellcome-user">
                            <a class="nav-link item-profile" id="user" routerLink="/usuario/perfil" (click)="noViewMenuPrincipal()"><img src="../../assets/icons/profile-user.svg" class="img-profile"/>{{nombreUsuario}} </a>                  
                        </div>
                    </ng-template>
        
                    <ul class="nav flex-column ">
                        <li class="nav-item">
                            <a class="nav-link item-toyota"  routerLink="" (click)="noViewMenuPrincipal()">Inicio</a>
                        </li>
                    </ul>
                    <ul class="nav flex-column ">
                        <li class="nav-item">
                            <a class="nav-link item-toyota" (click)="isCollapsedPostVenta = !isCollapsedPostVenta" [attr.aria-expanded]="!isCollapsedPostVenta" aria-controls="collapsePostVenta">
                                Servicios
                            </a>
                            <div class="ps-4" id="collapsePostVenta" [ngbCollapse]="!isCollapsedPostVenta">
                                <ul class="nav flex-column pl-3 submenu-toyota">
                                    <li class="nav-item"><a class="nav-link" routerLink="/servicios/seguros-individuales" (click)="noViewMenuPrincipal()">Servicios Individuales</a></li>
                                    <li class="nav-item"><a class="nav-link" routerLink="/servicios/seguros-corporativos" (click)="noViewMenuPrincipal()">Seguros Corporativos</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link item-toyota" (click)="isCollapsedSiniestro = !isCollapsedSiniestro" [attr.aria-expanded]="!isCollapsedSiniestro" aria-controls="collapsedSiniestro">
                                Siniestros
                            </a>
                            <div class="ps-4" id="collapsedSiniestro" [ngbCollapse]="!isCollapsedSiniestro">
                                <ul class="nav flex-column pl-3 submenu-toyota">
                                    <li class="nav-item"><a class="nav-link" routerLink="/servicios/procedimiento-para-siniestros/generales" (click)="noViewMenuPrincipal()">Siniestros Generales</a></li>
                                    <li class="nav-item"><a class="nav-link" routerLink="/servicios/procedimiento-para-siniestros/automotor" (click)="noViewMenuPrincipal()">Siniestros Automotor</a></li>
                                    <li class="nav-item"><a class="nav-link" routerLink="/servicios/seguimiento-de-siniestros" (click)="noViewMenuPrincipal()">Seguimiento de siniestros</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link item-toyota" routerLink="sucursales" (click)="noViewMenuPrincipal()">Sucursales</a>
                        </li>
                        <li class="nav-item mb-4" *ngIf="!user">
                            <a class="nav-link pb-4 item-toyota"  routerLink="login" (click)="noViewMenuPrincipal()">Ingresar</a>
                        </li>
                        <div class="my-4 separador" *ngIf="user"></div>
                        <li class="nav-item" *ngIf="user">
                            <a class="nav-link item-toyota"  routerLink="/usuario/perfil" (click)="noViewMenuPrincipal()">Tu Perfil</a>
                        </li>
                    </ul>
                    
                    
                    <div class="row mb-4 salir" *ngIf="user">
                        <a class="py-4 ms-2 text-white item-out" (click)="logout()"><img src="../../../assets/icons/logout.png" class="icon-out"/> Salir</a>
                    </div>
                    
                </div>
            </div>     
        </div>
    </div>
</div>